import * as PrintingOption from "../constants/PrintingOption";
import * as URLRequestParameters from "../constants/URLRequestParameters";
import {currentLoginInfo} from "../login/LoginPresenter";
import * as ts from "./Translator";
import {translateId} from "./Translator";
import * as DownloadPurpose from "../constants/DownloadPurpose";
import {addCommonParametersToRequest, ajaxJSON} from "./NamaCommon";
import * as NamaURLS from "../constants/NamaURLS";
import {requestParam} from "../routing/ReportViewerPresenter";
import * as PlaceTokens from "../constants/PlaceTokens";
import {currentTimeMillis, getCustomGUISettings, getPrintUsingNamaServer} from "../login/ClientCache";
import {toCSVLineWithSep} from './StringUtils'
import * as notifier from "./ErrorsNotification";
import {getServerAddressWithERP, isMobileDevice} from "./GUIUtilities";
import {RunReport} from "../constants/NamaURLS";


export function openUrlInNewWindow(url) {
    window.open(url, "_blank", "");
}

export function printNext(urls, startFrom) {
    if (!urls || startFrom >= urls.length)
        return;
    for (let i = startFrom; i < urls.length && i - startFrom < 10; i++) {
        let url = urls[i];
        if (url.contains("yesToNewPNama")) {
            openUrlInNewWindow(url);
        }
        else {
            let frameNumber = (i - startFrom <= 0) ? "" : i - startFrom;
            document.getElementById("__printingFrame" + frameNumber).src = url;
        }
    }
    if (startFrom + 10 >= urls.length)
        return;
    setTimeout(() => {
        printNext(urls, startFrom + 10);
    }, 500);

}

export function getDirectPrintOption() {
    if (currentLoginInfo().directPrint)
        return PrintingOption.DIRECT;
    else
        return PrintingOption.DIALOG;
}

export function titleToParam(tabTitle, pageIndex) {
    if (!tabTitle)
        return "";
    let params = "";
    let arabic = ts.translateNaMaTextAr(tabTitle);
    let english = ts.translateNaMaTextEn(tabTitle);
    if (tabTitle.resourceId)
        params += tabTitle.resourceId;
    if (arabic)
        params += ((params) ? "," : "") + arabic;
    if (english)
        params += ((params) ? "," : "") + english;
    if (pageIndex)
        params += ((params) ? "," : "") + ((pageIndex + 1) + ",");
    return params;
}

export function printForm(entityType, id, tabTitle, format, viewName, pageIndex, menuCode, fromPrintButton) {
    /**
     * @type {namaTypes.LaunchReportRequest}
     */
    let request = {
        questions: "",
        reportId: "",
        outputFormat: format,
        printingOption: getDirectPrintOption(),
        downloadPurpose: DownloadPurpose.PRINT,
        entityType: entityType,
        entityId: id,
        tabId: titleToParam(tabTitle, pageIndex),
        viewName: viewName,
        isForm: true,
        menuCode: menuCode
    };
    addCommonParametersToRequest(request);
    ajaxJSON(NamaURLS.IsPrintReportPossible, {
        request: JSON.stringify(request)
    }, (result) => {
        if (result)
            printNext_(tabTitle, pageIndex, request, fromPrintButton);
        else
            notifier.showError(translateId("couldNotFindFormToPrintRecord"));
    });
}

function printUsingPrintingServer(params) {
    let body = {printParams: params, url: getServerAddressWithERP()};
    let port = 9494;
    let printURl = "http://localhost:" + port + "/namaPrint";
    ajaxJSON(printURl, {
        contentType: "text/plain",
        ajaxRequestDataType: "text",
        actualData: JSON.stringify(body)
    }, (response) => {
        if ("done" === response)
            notifier.showSuccess(response);
        else
            notifier.showError(translateId("Error :  " + response));
    }, (error) => {
        notifier.showErrors("There is no connection on port " + port
            + ", please make sure that the printing server is running. <br/>You can install the printing server from <a href='https://www.namasoft.com/bin/printing-server/printing-server/printing-server-launcher.exe' target='_blank'>here</a><br/>If you already have it please <a href='nama-printing-server://start'> run it fom here</a>"
            + "<br/>If you are using chrome make sure that the option <a target='_blank' href='chrome://flags/#block-insecure-private-network-requests'>chrome://flags/#block-insecure-private-network-requests</a> is disabled");
    });
}

function printNext_(tabTitle, pageIndex, request, fromPrintButton) {
    if (fromPrintButton && getPrintUsingNamaServer() && !isMobileDevice()) {
        ajaxJSON(RunReport, {
            request: JSON.stringify(request)
        }, (result) => {
            if (result) {
                let params = result.list;
                printUsingPrintingServer(params);
            } else {
                notifier.showError(translateId("couldNotFindPrintTempId"));
            }
        });
    } else {
        let urls = [createURL(request.entityType, request.entityId, tabTitle, request.outputFormat, request.viewName, request.isForm, pageIndex, request.reportId, request.menuCode)];
        printNext(urls, 0);
    }
}

function createURL(entityType, id, tabTitle, format, viewName, form, pageIndex, reportId, menuCode) {
    let request = {};
    addCommonParametersToRequest(request);
    let url = "runreport.rpt?" + requestParam(PlaceTokens.PRM_OUTPUT_FORMAT, format);
    url += requestParam(URLRequestParameters.DEPARTMENT, request.dep);
    url += requestParam(URLRequestParameters.ANALYSIS_SET, request.an);
    url += requestParam(URLRequestParameters.BRANCH, request.br);
    url += requestParam(URLRequestParameters.SECTOR, request.sc);
    url += requestParam(URLRequestParameters.LEGAL_ENTITY, request.leg);
    url += requestParam(PlaceTokens.PRM_PRINTING_OPTION, getDirectPrintOption());
    if (isAdobeReaderInstalled() || getCustomGUISettings().openPrintInBrowserWindow)
        url += requestParam(PlaceTokens.PRM_DOWNLOAD_PURPOSE, DownloadPurpose.PRINT);
    else
        url += requestParam(PlaceTokens.PRM_DOWNLOAD_PURPOSE, DownloadPurpose.DOWNLOAD);
    url += requestParam("timeStamp", currentTimeMillis());
    url += requestParam(PlaceTokens.PRM_ENTITY_TYPE, entityType);
    url += requestParam(PlaceTokens.PRM_ENTITYID, id);
    url += requestParam(PlaceTokens.PRM_PAGE_ID, titleToParam(tabTitle, pageIndex));
    url += requestParam(PlaceTokens.PRM_LANGUAGE, ts.locale);
    url += requestParam(PlaceTokens.PRM_VIEW, viewName);
    url += requestParam(PlaceTokens.PRM_IS_FORM, form);
    url += requestParam(PlaceTokens.PRM_FORM_REPORT_ID, reportId);
    if (getCustomGUISettings().openPrintInBrowserWindow)
        url += requestParam("newP", "yesToNewPNama");
    url += requestParam(PlaceTokens.PRM_MENU_HASH, menuCode);
    return url;
}

function isAdobeReaderInstalled() {
    let isInstalled = false;
    if (window.ActiveXObject) {
        let control = null;
        try {
            // AcroPDF.PDF is used by version 7 and later
            control = new ActiveXObject('AcroPDF.PDF');
        } catch (e) {
        }
        if (!control) {
            try {
                // PDF.PdfCtrl is used by version 6 and earlier
                control = new ActiveXObject('PDF.PdfCtrl');
            } catch (e) {
            }
        }
        if (control)
            isInstalled = true;
    } else {
        // Check navigator.plugins for "Adobe Acrobat" or "Adobe PDF Plug-in"*
        for (let i = 0; i < navigator.plugins.length; i++) {
            let n = navigator.plugins[i].name;
            if (n.indexOf('Adobe Acrobat') > -1 || n.indexOf('Adobe PDF') > -1) {
                isInstalled = true;
                break;
            }
        }
    }
    return isInstalled;
}

export function printList(entityType, ids, format, viewName, pageIndex, menuCode) {
    if (!ids || !ids.length)
        return;
    let url = [];
    url.push(createURL(entityType, toCSVLineWithSep(",", ids), null, format, viewName, false, pageIndex, "", menuCode));
    printNext(url, 0);
}
